/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../cardr/issuing/model';
import '../../common/time';
import '../../bizbank/card';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "Card": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.cardr.issuing.CardState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "creditLineId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "externalCardId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "applicationFlowId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "activatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "creditLineToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "externalCardHolderId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "issuedCardToken": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "cardHolderToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "internalCardToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "externalCardToken": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "cardStatus": {
                    "type": ".squareup.bizbank.cards.CardStatus",
                    "id": 17,
                    "rule": "optional"
                  },
                  "fulfillmentStatus": {
                    "type": ".squareup.bizbank.cards.CardFulfillment.FulfillmentStatus",
                    "id": 18,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": ".squareup.bizbank.cards.CardBrand",
                    "id": 19,
                    "rule": "optional"
                  },
                  "cardType": {
                    "type": ".squareup.bizbank.cards.CardType",
                    "id": 20,
                    "rule": "optional"
                  },
                  "cardHolderName": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "issuerProcessor": {
                    "type": ".squareup.corporate_card.resources.Card.IssuerProcessor",
                    "id": 22,
                    "rule": "optional"
                  },
                  "cardPairToken": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "reissuedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 24,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "IssuerProcessor": {
                    "values": {
                      "IP_DO_NOT_USE": 0,
                      "I2C": 1,
                      "MARQETA": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.Card && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.Card?.nested?.IssuerProcessor) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A corporate card
 * --
 *
 * SOURCE Card @ squareup/corporate_card/resources/card.proto at 12:1
 */
export const Card = $root.lookupType('squareup.corporate_card.resources.Card');
fixType(Card);
Builder.createAndAttachToType(Card);
/**
 * SOURCE IssuerProcessor @ squareup/corporate_card/resources/card.proto at 13:3
 */
Card.IssuerProcessor = $root.lookupEnum('squareup.corporate_card.resources.Card.IssuerProcessor').values;